// Third party
import React from 'react';

// Utils
import { FormattedMessage } from '@/utils/i18n';

const ESGEmptyData = () => (
  <div className="esg-empty-data">
    <span className="esg-empty-data-icon">
      <i className="icon-no-data" />
    </span>
    <FormattedMessage tagName="h4" id="ESGComparisonTool.NoData.Title" />
    <FormattedMessage tagName="p" id="ESGComparisonTool.NoData.SubTitle" />
  </div>
);

export default ESGEmptyData;
